import {useUsersView} from 'api/modules/obsView';
import {useSetMedia, useSetStyle} from 'api/modules/streamer';
import classNames from 'classnames';
import React from 'react';
import {ScreenDTO} from 'types/dtos/Screen';
import {ObsRoom} from 'types/entities/Obs';

type ObsScreenAndUsersProps = {
  screen: ScreenDTO;
  room: ObsRoom;
  isFirst: boolean;
};

const basicCss = `
#gridlayout div {
  transition: all 700ms;
  width: auto !important;
}

#gridlayout video {
  object-fit: cover !important;
}
`;

const aspectRatio1 = `
#gridlayout div {
  aspect-ratio: 1 / 1 !important;
}
`;

const aspectRatio16 = `
#gridlayout div {
  aspect-ratio: 16 / 9 !important;
}
`;

const aspectRatioHalf = `
#gridlayout div {
  aspect-ratio: 16 / 18 !important;
}
`;

const left = `
#gridlayout div {
  left: 0 !important;
  right: auto !important;
}
`;

const right = `
#gridlayout div {
  left: auto !important;
  right: 0 !important;
}
`;

const ObsScreenAndUsers: React.FC<ObsScreenAndUsersProps> = ({
  screen,
  room,
  isFirst,
}) => {
  const obsUsers = useUsersView();
  const setMdeia = useSetMedia();
  const setStyle = useSetStyle();

  const screens = [1, 5, 2, 7];

  if (!obsUsers.isSuccess) return <p>Loading...</p>;

  return (
    <div
      className={classNames(
        'inline-block mt-2 w-32 align-top',
        isFirst ? 'mr-2' : 'mx-2',
      )}
    >
      <div
        className="h-32 text-center font-bold text-xl border mb-1"
        style={{lineHeight: '8rem'}}
      >
        {screen.ScreenId}
      </div>

      <div className="grid grid-flow-col gap-y gap-x-2">
        <div
          className="border p-2 my-1 text-center cursor-pointer"
          onClick={() =>
            setStyle.mutate({
              screenId: screen.ScreenId,
              style: basicCss,
            })
          }
          aria-hidden="true"
        >
          Basic style
        </div>
      </div>

      <div className="grid grid-flow-col gap-y gap-x-2">
        <div
          className="border p-2 my-1 text-center cursor-pointer"
          onClick={() =>
            setStyle.mutate({
              screenId: screen.ScreenId,
              style: aspectRatio1,
            })
          }
          aria-hidden="true"
        >
          1
        </div>
        <div
          className="border p-2 my-1 text-center cursor-pointer"
          onClick={() =>
            setStyle.mutate({
              screenId: screen.ScreenId,
              style: aspectRatio16,
            })
          }
          aria-hidden="true"
        >
          16
        </div>
        <div
          className="border p-2 my-1 text-center cursor-pointer"
          onClick={() =>
            setStyle.mutate({
              screenId: screen.ScreenId,
              style: aspectRatioHalf,
            })
          }
          aria-hidden="true"
        >
          1/2
        </div>
      </div>

      <div className="grid grid-flow-col gap-y gap-x-2">
        <div
          className="border p-2 my-1 text-center cursor-pointer"
          onClick={() =>
            setStyle.mutate({
              screenId: screen.ScreenId,
              style: left,
            })
          }
          aria-hidden="true"
        >
          left
        </div>
        <div
          className="border p-2 my-1 text-center cursor-pointer"
          onClick={() =>
            setStyle.mutate({
              screenId: screen.ScreenId,
              style: right,
            })
          }
          aria-hidden="true"
        >
          right
        </div>
      </div>

      <div className="grid grid-flow-col gap-y gap-x-2">
        <div
          className="border p-2 my-1 text-center cursor-pointer"
          onClick={() =>
            setMdeia.mutate({
              screenId: screen.ScreenId,
              // mediaId: `https://obs.ninja/?scene=${x}&room=${room.roomName}&password=${room.password}&webp`,
              mediaId: `https://vdo.ninja/?room=${room.roomName}&password=${room.password}&autostart&novideo&webcam&l=MASTER&sink=f9074a3178542a74ef3e52ccfaf92af4c6b9a1a40fff71537c17e73d08954197`,
            })
          }
          aria-hidden="true"
        >
          Full call
        </div>
        <div
          className="border p-2 my-1 text-center cursor-pointer"
          onClick={() =>
            setMdeia.mutate({
              screenId: screen.ScreenId,
              mediaId: `nothing`,
            })
          }
          aria-hidden="true"
        >
          Nothing
        </div>
      </div>
      <div className="grid grid-rows-2 grid-flow-col gap-y gap-x-2">
        {screens.map((x, index) => (
          <div
            className="border p-2 my-1 text-center cursor-pointer"
            onClick={() =>
              setMdeia.mutate({
                screenId: screen.ScreenId,
                // mediaId: `https://obs.ninja/?scene=${x}&room=${room.roomName}&password=${room.password}&webp`,
                mediaId: `https://vdo.ninja/?scene=${x}&room=${room.roomName}&password=${room.password}&webp&transparent`,
              })
            }
            aria-hidden="true"
            key={index}
          >
            s{x}
          </div>
        ))}
      </div>

      {obsUsers.data.map((x, index) => (
        <div
          className="w-full border p-2 my-1 text-center cursor-pointer"
          onClick={() =>
            setMdeia.mutate({
              screenId: screen.ScreenId,
              // mediaId: `https://obs.ninja/?view=${x.streamID}&scene&room=${room.roomName}&password=${room.password}`,
              mediaId: `https://vdo.ninja/?view=${x.streamID}&scene&room=${room.roomName}&password=${room.password}&webp&transparent`,
            })
          }
          aria-hidden="true"
          key={index}
        >
          {x.label || x.streamID}
          {x.currentScreen}
        </div>
      ))}
    </div>
  );
};

export default ObsScreenAndUsers;
